import React from 'react'
import { Link } from 'react-router-dom'
import { Alert, Box, Button } from '@mantine/core'

import { AttendeesCard } from './components/AttendeesCard'
import { Card } from './components/Card'
import { DetailsCard } from './components/DetailsCard'
import { Layout } from './components/Layout'

import { Event } from '@/types'

export const UnavailableEventDetail: React.FC<{
  event: Event
}> = ({ event }) => {
  return (
    <Layout
      left={
        <>
          <Alert
            title="This event is not available for booking."
            color="orange"
          >
            Unfortunately, you cannot book this event.
          </Alert>
          <Card>
            <Box m="md">
              <Button
                component={Link}
                to="/calendar"
                variant="light"
                color="gray"
              >
                Back to calendar view
              </Button>
            </Box>
          </Card>
        </>
      }
      right={
        <>
          <DetailsCard event={event} />
          <AttendeesCard event={event} />
        </>
      }
    />
  )
}
